module.exports = __webpack_public_path__ + "static/media/Project-japan.37e3fa56.svg";